export function getByType(type) {
  const today = new Date();
  let start, end; //, timeGranularityType
  switch (type) {
    case 0: // 今天
      start = new Date(today);
      end = new Date(today);
      // timeGranularityType = 5;
      break;
    case 1: // 昨天
      start = new Date(today);
      start.setDate(today.getDate() - 1);
      end = new Date(start);
      // timeGranularityType = 5;
      break;
    case 2: // 本週（週日~週六）
      start = new Date(today);
      start.setDate(today.getDate() - today.getDay());
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      // timeGranularityType = 4;
      break;
    case 3: // 本月
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // timeGranularityType = 3;
      break;
    case 4: // 上個月
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
      // timeGranularityType = 3;
      break;
    case 5: // 今年
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date(today.getFullYear(), 11, 31);
      // timeGranularityType = 1;
      break;
    case 6: // 去年
      start = new Date(today.getFullYear() - 1, 0, 1);
      end = new Date(today.getFullYear() - 1, 11, 31);
      // timeGranularityType = 1;
      break;
    case 7: // 過去7天（含今天）
      end = today;
      start = new Date(today);
      start.setDate(today.getDate() - 6);
      // timeGranularityType = 4;
      break;
    case 8: // 過去30天（含今天）
      end = today;
      start = new Date(today);
      start.setDate(today.getDate() - 29);
      // timeGranularityType = 3;
      break;
    default:
      throw new Error(`Unsupported type: ${type}`);
  }

  return {
    DayBegin: formatDate(start),
    DayEnd: formatDate(end),
    // TimeGranularityType: timeGranularityType,
  };
}

function formatDate(date) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  return `${y}-${m}-${d}`;
}

export default { getByType };
